import type { NavCategory, Product } from "@/components/marketplace/types"

import type { SearchDiscovery } from "./types"

// Stubbed discovery assembler. Today it composes the sections from data the
// chrome already has (trending terms, suggested products, categories); when the
// api-v2 search-discovery endpoint lands, this is the seam its response slots
// into — the overlay consumes `SearchDiscovery` either way. Sections with no
// content (empty suggested) are dropped so the overlay never renders a blank block.
export const buildDiscovery = ({ trending, suggested, categories }: { trending: string[]; suggested: Product[]; categories: NavCategory[] }): SearchDiscovery => ({
  sections: [
    { type: "recent" },
    ...(trending.length ? [{ type: "trending", items: trending } as const] : []),
    ...(suggested.length ? [{ type: "suggested", items: suggested } as const] : []),
    ...(categories.length
      ? [
          {
            type: "browseCategories",
            items: categories.map((category) => ({ label: category.label, handle: category.handle, path: category.path, photo: category.photo })),
          } as const,
        ]
      : []),
  ],
})
